import { Trash } from "components/icons/generated";
import ListEntitiesItem from "components/ListEntitiesItem";
import ListEntitiesItemLink from "components/ListEntitiesItem/Link";
import ProjectTypeBadge, { ProjectType } from "components/ProjectTypeBadge";
import SpacePath from "components/SpacePath";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import Timestamp from "components/Timestamp";
import useCanManageStack from "shared/Stack/access/useCanManageStack";
import { NO_ACCESS_MESSAGE } from "utils/access";

import { COLUMN_ORDER_USED_BY } from "../../constants";
import { showDetachContextConfirmation } from "./DetachContextConfirmation";
import { ContextUsedByAttachedItemProps } from "./types";

const ContextUsedByAttachedItem = ({ className, item }: ContextUsedByAttachedItemProps) => {
  const canDetachContext = useCanManageStack()({
    spaceDetails: item.stackSpaceDetails,
    space: item.stackSpaceDetails.id,
    isLockedByTemplateDeployment: false,
  });

  const isModule = item.isModule;

  const handleDetachClick = () =>
    showDetachContextConfirmation({
      id: item.id,
      name: item.stackName,
      isModule,
    });

  return (
    <ListEntitiesItem
      className={className}
      grid
      gridTemplate={COLUMN_ORDER_USED_BY}
      gap="0 large"
      key={item.id}
      role="row"
    >
      <Box role="cell" align="center" gap="medium" fullWidth grow="1">
        <ProjectTypeBadge projectType={isModule ? ProjectType.Module : ProjectType.Stack} />
      </Box>
      <Box role="rowheader" align="center" gap="medium" fullWidth grow="1">
        <ListEntitiesItemLink
          href={`/${isModule ? "module" : "stack"}/${item.stackId}`}
          title={item.stackName}
        />
      </Box>

      <Box role="cell" direction="column" justify="center">
        <SpacePath
          spaceId={item.stackSpaceDetails.id}
          fallbackName={item.stackSpaceDetails.name}
        />
      </Box>

      <Box role="cell" align="center">
        {!item.isAutoattached && item.createdAt && (
          <Timestamp timestamp={item.createdAt} color="primary" />
        )}
      </Box>
      <Box role="cell" align="center" justify="end">
        {!item.isAutoattached && (
          <ButtonIcon
            icon={Trash}
            onPress={handleDetachClick}
            variant="ghostDanger"
            disabled={!canDetachContext.result}
            forceTooltip={!canDetachContext.result}
          >
            {canDetachContext.result ? "Detach" : canDetachContext.message || NO_ACCESS_MESSAGE}
          </ButtonIcon>
        )}
      </Box>
    </ListEntitiesItem>
  );
};

export default ContextUsedByAttachedItem;
